<template>
  <div
    class="flex flex-wrap items-center justify-between gap-1.5 border-b border-slate-200 bg-[#f8fafc] px-4 py-2"
  >
    <span class="text-xs text-slate-500">
      {{ count }} device{{ count === 1 ? '' : 's' }} selected
    </span>
    <div class="flex items-center gap-1">
      <button
        v-if="showUnarchive"
        type="button"
        class="rounded px-2 py-1 text-xs text-green-600 hover:bg-slate-100"
        @click="$emit('unarchive')"
      >
        Unarchive
      </button>
      <button
        v-if="showArchive"
        type="button"
        class="rounded px-2 py-1 text-xs text-slate-500 hover:bg-slate-100"
        @click="$emit('archive')"
      >
        Archive
      </button>
      <button
        type="button"
        class="rounded px-2 py-1 text-xs text-slate-500 hover:bg-slate-100"
        @click="$emit('export')"
      >
        Export
      </button>
      <button
        type="button"
        class="rounded px-2 py-1 text-xs text-slate-500 hover:bg-slate-100"
        @click="$emit('clear')"
      >
        Clear
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  count: number;
  showArchive: boolean;
  showUnarchive: boolean;
}>();

defineEmits<{
  (e: 'archive'): void;
  (e: 'unarchive'): void;
  (e: 'export'): void;
  (e: 'clear'): void;
}>();
</script>
